import React from 'react'
import DropDown from 'wix-base-ui/lib/controls/dropDown'
import IconButton from './iconButton.jsx'
import _ from 'lodashParts'
import DefaultLinkDialog from './defaultLinkDialog.jsx'
import constants from '../../utils/constants'

class LinkPicker extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            defaultLinkDialogOpen: false,
            selectedLink: null
        }
    }

    removeLink() {
        this.props.execCommand('wixUnlink')
    }

    isLinkEmpty() {
        return !this.props.value
    }

    expandLink() {
        this.props.expandLinkSelection()
    }

    handleDialogClosed(link) {
        if (link) {
            this.props.execCommand('wixLink', link)
        } else {
            this.removeLink()
        }

        if (!this.props.openLinkDialog) {
            this.setState({defaultLinkDialogOpen: false})
        }

    }

    openLinkDialog() {
        const link = this.props.value

        if (this.props.openLinkDialog) {
            this.props.openLinkDialog(link, newLink => this.handleDialogClosed(newLink))
        } else {
            this.setState({defaultLinkDialogOpen: true, selectedLink: link})
        }
    }

    doLinkAction(val) {
        if (val === 'link') {
            this.openLinkDialog()
        } else if (val === 'unLink') {
            this.removeLink()
        }
    }

    isDisabled() {
        return this.props.disabled || this.props.value === constants.TRISTATE_DISABLED
    }
    render() {
        const self = this

        function renderDefaultOpenDialogIfNeeded() {
            if (!self.props.openLinkDialog) {
                return (
                    <DefaultLinkDialog
                        isOpen={self.state.defaultLinkDialogOpen}
                        value={self.state.selectedLink}
                        onDialogClosed={link => self.handleDialogClosed(link)}
                        onCancel={() => self.setState({defaultLinkDialogOpen: false})}
                    />
                )
            }
        }

        if (this.isLinkEmpty() || this.props.disabled) {
            return (
                <span key="link-button">
                    {renderDefaultOpenDialogIfNeeded()}
                    <IconButton automationId={this.props.automationId} key="link-button" onClick={() => {this.openLinkDialog()}} disabled={this.isDisabled()} symbol="textLink"/>
                </span>
            )
        }

        return (
            <span>
                {renderDefaultOpenDialogIfNeeded()}
                <DropDown hasArrowIcon={false}
                          className="richtext-context-dropdown toolbar-mode"
                          optionsContainerClassName="richtext-context-dropdown-options"
                          onChange={ val => this.doLinkAction(val)}
                          key="link-dropdown"
                          automationId={this.props.automationId}
                          value="link">
                    <IconButton value="unLink" symbol="textUnlink" key="unlink"/>

                    <IconButton value="link"
                                onClick={() => this.expandLink()}
                                className="selected"
                                key="link"
                                symbol="textLink"/>
                </DropDown>
            </span>
        )
    }
}

LinkPicker.defaultProps = {
    execCommand: _.noop,
    expandLinkSelection: _.noop
}

LinkPicker.propTypes = {
    value: React.PropTypes.oneOfType([
        React.PropTypes.string,
        React.PropTypes.number
    ]),
    openLinkDialog: React.PropTypes.func,
    execCommand: React.PropTypes.func,
    expandLinkSelection: React.PropTypes.func,
    disabled: React.PropTypes.bool
}

module.exports = LinkPicker



// WEBPACK FOOTER //
// ./src/components/toolbar/linkPicker.jsx